import { MasterDataContainer } from '../../dataAccess/masterDataContainer';
import { HojyoKmkInfoCacheViewModel } from './hojyoKmkInfoCacheViewModel';

export class HojyoKmkInfoCacheContainer extends MasterDataContainer<HojyoKmkInfoCacheViewModel> {
    constructor(models: Array<HojyoKmkInfoCacheViewModel>, dataYear: number, version: Date) {
        super(models, dataYear, version);
    }
}